const setQuyen = (quyenTruyCap) => {
    return {
        type: "SET_QUYEN",
        payload: quyenTruyCap
    }
}

const deleteQuyen = () => {
    return {
        type: "DELETE_QUYEN"
    }
}

export default {
    setQuyen,
    deleteQuyen
}